import React, { useState, useContext, Component, createRef } from "react";
import CartContext from "./CartContext";
import { BlobServiceClient } from "@azure/storage-blob";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { LoadSpinner } from "./LoadSpinner";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import axios from "axios";

import { Row, Col, Table, Form, Button } from "react-bootstrap";

export default class UserProducts extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      stores: [],
      loadSpinnerOpen: false,
      currentOrderRow: "",
      invoiceHtml: "",
    };
    this.inputFile = React.createRef();
  }

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };

  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  GetStores = () => {
    this.ShowLoadSpinner();
    console.log(`Bearer ${this.context.userData.bearerToken}`);
    fetch(
      process.env.REACT_APP_API +
        "Sales/GetStoresByTenantId/" +
        this.context.userData.id,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${this.context.userData.bearerToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404) {
          this.HideLoadSpinner();
          return;
        }
        this.setState({ stores: data });
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
      });
  };

  IsReadyForRenewal = (store) => {
    let expirydate = new Date(store.storeEnd);
    const diffTime = Math.abs(new Date() - expirydate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (
      (new Date() < expirydate && diffDays <= 30) ||
      new Date() > expirydate
    ) {
      return true;
    }
    return false;
  };
  RenewProduct = (store) => {};

  componentDidMount() {
    window.scrollTo(0, 0);
    this.GetStores();
  }

  render() {
    if (this.context.userData.loginStatus != "active")
      return <Navigate to="/home" />;
    return (
      <>
        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}

        <div className="mx-0 px-1 bg-white w-100">
          <div className="row mt-2 mx-0 px-2">
            <div className="col-md-12">
              <h3 className="producttitlefontandsizeDesktop">
                <b>My Stores/Products</b>
              </h3>
              <br />

              {/* Desktop Table View */}
              <div className="d-none d-md-block">
                <Table responsive striped bordered>
                  <thead className="bg-light text-center text-primary">
                    <tr>
                      <th>#</th>
                      <th>Created</th>
                      <th>Business</th>
                      <th>Product</th>
                      <th>License</th>
                      <th>Users</th>
                      <th>Data Retention</th>
                      <th>SEO</th>
                      <th>Txn Fee</th>
                      <th>Start</th>
                      <th>Expiry</th>
                      <th>Monthly ₹</th>
                      <th>Links</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.stores
                      .sort((a, b) => (a.created > b.created ? 1 : -1))
                      .map((p, i) => (
                        <tr key={p.id} className="text-center align-middle">
                          <td>{i + 1}</td>
                          <td>
                            {this.context.GetInDateFormat(new Date(p.created))}
                          </td>
                          <td>{p.name}</td>
                          <td>
                            {
                              this.context.GetProductByType(p.productTypeId)
                                .name
                            }
                          </td>
                          <td>
                            {this.context.GetLicenseTypeNameById(p.storeTypeId)}
                          </td>
                          <td>{p.totalUsers}</td>
                          <td>
                            {p.dataRetensionMonths === 0
                              ? this.context.GetEcSettingValueByName(
                                  "dataRententionFreeDays"
                                ) + " Days"
                              : `${p.dataRetensionMonths} Months`}
                          </td>
                          <td>{p.enableSeo ? "true" : "false"}</td>
                          <td>
                            {this.context.IsECommerceProduct(p.productTypeId)
                              ? `${p.transactionCharges}%`
                              : ""}
                          </td>
                          <td>
                            {this.context.GetInDateFormat(
                              new Date(p.storeStart)
                            )}
                          </td>
                          <td>
                            <b>
                              {this.context.GetInDateFormat(
                                new Date(p.storeEnd)
                              )}
                            </b>
                            {this.IsReadyForRenewal(p) && (
                              <Button
                                as={Link}
                                className="mt-1 w-100"
                                to="/RenewProduct"
                                onClick={() =>
                                  this.context.SetSelectedProduct(p)
                                }
                              >
                                Renew
                              </Button>
                            )}
                          </td>
                          <td>
                            {this.context
                              .GetMonthlyCostOfStore(p)
                              .toLocaleString("en-IN", {
                                style: "currency",
                                currency: "INR",
                                minimumFractionDigits: 0,
                              })}
                          </td>
                          <td className="text-start">
                            <a
                              href={`https://${p.storeAdminDomainName}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <u>Admin Portal</u>
                            </a>
                            <br />
                            {this.context.IsECommerceProduct(
                              p.productTypeId
                            ) && (
                              <a
                                href={`https://${p.storeDomainName}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u>Customer Portal</u>
                              </a>
                            )}
                            <br />
                            {[
                              this.context.LicenseType.Retail_POS,
                              this.context.LicenseType.Restaurant_POS,
                              this.context.LicenseType.Retail_ERP,
                              this.context.LicenseType.Restaurant_ERP,
                              this.context.LicenseType.ERP,
                              this.context.LicenseType.SupplyChain,
                            ].includes(
                              this.context.ProductType[p.productTypeId]
                            ) && (
                              <>
                                <a
                                  href={`https://${p.storePosDomainName}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <u>POS Portal</u>
                                </a>
                              </>
                            )}
                          </td>
                          <td>
                            <b>
                              {
                                this.context.storeStatusTypes.find(
                                  (f) => f.id === p.storeStatusId
                                )?.statusName
                              }
                            </b>
                          </td>
                          <td>
                            {p.storeTypeId < 4 && (
                              <Button
                                as={Link}
                                className="mb-1 w-100"
                                to="/UpgradeProduct"
                                onClick={() =>
                                  this.context.SetSelectedProduct(p)
                                }
                              >
                                Upgrade
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>

              {/* Mobile Card View */}
              <div className="d-md-none">
                {this.state.stores
                  .sort((a, b) => (a.created > b.created ? 1 : -1))
                  .map((p, i) => (
                    <div
                      key={p.id}
                      className="border rounded mb-3 p-2 shadow-sm"
                    >
                      <h5>{p.name}</h5>
                      <p>
                        <strong>Product:</strong>{" "}
                        {this.context.GetProductByType(p.productTypeId).name}
                      </p>
                      <p>
                        <strong>License:</strong>{" "}
                        {this.context.GetLicenseTypeNameById(p.storeTypeId)}
                      </p>
                      <p>
                        <strong>Users:</strong> {p.totalUsers}
                      </p>
                      <p>
                        <strong>Data Retention:</strong>{" "}
                        {p.dataRetensionMonths === 0
                          ? this.context.GetEcSettingValueByName(
                              "dataRententionFreeDays"
                            ) + " Days"
                          : `${p.dataRetensionMonths} Months`}
                      </p>
                      <p>
                        <strong>Monthly Cost:</strong>{" "}
                        {this.context
                          .GetMonthlyCostOfStore(p)
                          .toLocaleString("en-IN", {
                            style: "currency",
                            currency: "INR",
                            minimumFractionDigits: 0,
                          })}
                      </p>
                      <p>
                        <strong>Expiry:</strong>{" "}
                        {this.context.GetInDateFormat(new Date(p.storeEnd))}
                      </p>
                      <p>
                        <a
                          href={`https://${p.storeAdminDomainName}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Admin
                        </a>

                        {this.context.IsECommerceProduct(p.productTypeId) && (
                          <a
                            href={`https://${p.storeDomainName}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" | "}
                            Customer Portal
                          </a>
                        )}

                        {[
                          this.context.LicenseType.Retail_POS,
                          this.context.LicenseType.Restaurant_POS,
                          this.context.LicenseType.Retail_ERP,
                          this.context.LicenseType.Restaurant_ERP,
                          this.context.LicenseType.ERP,
                          this.context.LicenseType.SupplyChain,
                        ].includes(
                          this.context.ProductType[p.productTypeId]
                        ) && (
                          <>
                            <a
                              href={`https://${p.storePosDomainName}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" | "}
                              POS Portal
                            </a>
                          </>
                        )}
                      </p>
                      <div className="d-grid gap-2">
                        {this.IsReadyForRenewal(p) && (
                          <Button
                            size="sm"
                            as={Link}
                            to="/RenewProduct"
                            onClick={() => this.context.SetSelectedProduct(p)}
                          >
                            Renew
                          </Button>
                        )}
                        {p.storeTypeId < 4 && (
                          <Button
                            size="sm"
                            as={Link}
                            to="/UpgradeProduct"
                            onClick={() => this.context.SetSelectedProduct(p)}
                          >
                            Upgrade
                          </Button>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
